import { ActivatedRoute,Route } from '@angular/router'

export class PageRoute {
  public ID: string;
  public route: ActivatedRoute;
  private _url: string;
  public label: string;
  
  parameters:any=[];
  
  public pred:PageRoute=null;
  public next:PageRoute=null;	
  
 public getUrl() {
        return this._url;
  }

  public setUrl(route: ActivatedRoute) {
	   this.route=route;
       this._url=route.snapshot.url.join('/')
       
       
  }
  
  public checkRoute(route: ActivatedRoute) {
	  let ckecked:boolean=false;
	  ckecked=this.getUrl()!=route.snapshot.url.join("/");
	  
	  return ckecked
  }
  
}
